import { NavLink } from "react-router-dom";
import { PRIMARY_NAV } from "./nav";

/**
 * Phone-only bottom tab bar: four shortcuts for the sections opened daily.
 *
 * It is not the whole navigation — the burger at the top holds all eight. It
 * exists because on a phone the top-left corner is the furthest point from the
 * thumb, and «Сьогодні → Цілі» should not cost a reach plus two taps.
 */
export default function MobileTabBar() {
  return (
    <nav
      aria-label="Швидкі розділи"
      className="jv-safe-b fixed inset-x-0 bottom-0 z-30 grid grid-cols-4 border-t border-line bg-surface/95 backdrop-blur md:hidden"
    >
      {PRIMARY_NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            [
              "flex flex-col items-center justify-center gap-1 px-0.5 py-1.5 text-center transition-colors",
              isActive ? "text-accent" : "text-muted",
            ].join(" ")
          }
        >
          {({ isActive }) => (
            <>
              <item.Icon
                className={`size-5 transition-transform duration-200 ease-drawer ${
                  isActive ? "scale-110" : "scale-100"
                }`}
              />
              <span className="w-full truncate text-micro">{item.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
